import { Navigate, useLocation } from 'react-router-dom';
import { useAuthService } from '../services/authService.jsx';
import { CircularProgress, Box } from '@mui/material';

function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuthService();
  const location = useLocation();

  if (isLoading) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="100vh"
        sx={{ 
          backgroundColor: '#000000',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1000
        }}
      >
        <CircularProgress size={30} sx={{ color: '#ff0000' }} />
      </Box>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login with the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export default ProtectedRoute; 